import { Injectable } from '@angular/core';
import {
  CanActivate,
  UrlTree
} from '@angular/router';
import {AuthService} from './auth/auth.service';



@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {

  constructor(private auth: AuthService) {}

  public canActivate(): boolean | UrlTree {
    if (!this.auth.isAuthenticated()) {
     this.auth.login();
     return false;
    }
    return true;
  }
}
